define('lq/main',[
    'domready!',
    'module',
    'require',
    'underscore',
    'jquery',
    'lq/cookie'
], function (domready, module, require, _, $, cookie) {
    var config = module.config();
    var ravenLogger = null;
    var init = function (initCompleted) {
        if (config.ravenFrontEndDsn) {
            require(['raven'], function (Raven) {
                Raven.setUserContext({
                    id: config.userId
                });
                Raven
                    .config(config.ravenFrontEndDsn,
                        {
                            tags: {
                                location: 'front end',
                                environment: config.ravenEnvironment,
                                tenant: config.tenantName || '',
                                application: config.tenantApplicationName || '',
                                component: config.componentName || ''
                            },
                            dataCallback: function (data) {
                                data.fingerprint = ['{{ default }}', config.tenantName, config.tenantApplicationName];
                                return data;
                            }
                        })
                    .install();

                Raven
                    .context(function () {
                        ravenLogger = Raven;

                        initCompleted();
                    });
            });
        } else {
            initCompleted();
        }

        $(window).on('unload', function () {
            // without this handle Firefox will not run any javascript on page load after having pressed the 'Back' button of the browser
        });
    };

    var getNotificationsEntryPage = function () {
        return config.notificationsEntryPage;
    };

    var getNotificationIcon = function () {
        return config.notificationIcon;
    };

    var areWebNotificationsEnabled = function () {
        return config.areWebNotificationsEnabled && window.navigator.serviceWorker;
    };
    
    var getFirebaseWPCert = function () {
        return config.firebaseWPCert;
    };

    var getFirebaseAppId = function () {
        return config.firebaseAppId;
    };

    var getFirebaseProjectId = function () {
        return config.firebaseProjectId;
    };

    var getFirebaseSenderId = function () {
        return config.firebaseSenderId;
    };

    var getFirebaseApiKey = function () {
        return config.firebaseApiKey;
    };
    
    var getTenantName = function () {
        return config.tenantName;
    };

    var getTenantApplicationName = function () {
        return config.tenantApplicationName;
    };

    var getBaseUrl = function (path) {
        return config.baseUrl + path;
    };

    var getStylesVersion = function () {
        return config.stylesVersion;
    };

    var getCdnUrl = function (path) {
        return config.cdnUrl + path;
    };

    var getTenantUrl = function (path) {
        return config.tenantUrl + path;
    };

    var getTenantCdnUrl = function (path) {
        return config.tenantCdnUrl + path;
    };

    var getRuntimeUrl = function (path) {
        return config.runtimeUrl + path;
    };

    var getRuntimeBaseUrl = function (path) {
        return config.runtimeBaseUrl + path;
    };

    var getUserId = function () {
        return config.userId;
    };

    var getDesignerId = function () {
        return config.designerId;
    };

    var getDesignerUrl = function (path) {
        return config.designerUrl + path;
    };

    var getPortalUrl = function (path) {
        return config.designerBaseUrl + 'plumbing/tenant/' + config.tenantName + '/application/' + config.tenantApplicationName + '/' + path;
    };
    var getDesignerBaseUrl = function (path) {
        return config.designerBaseUrl + path;
    };

    var getTenantUploads = function (path) {
        return config.tenantUploads + path;
    };

    var getFrontEndUrl = function (path) {
        return config.frontEndUrl + path;
    };

    var getNameOfComponent = function () {
        return config.componentName;
    };

    var getRavenLogger = function () {
        return ravenLogger;
    };

    var setRavenLogger = function (instance) {
        ravenLogger = instance;
    };

    var getOrigin = function () {
        if (window.location.origin)
            return window.location.origin + '/';
        return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    };

    var getFullUrl = function (pathFromRoot) {
        if (pathFromRoot && pathFromRoot.indexOf('/') === 0)
            pathFromRoot = pathFromRoot.slice(1);
        return getOrigin() + pathFromRoot;
    };

    var getLanguageIsoCode = function () {
        return config.languageISOCode;
    };

    var inMockMode = !new URLSearchParams(window.location.search).get('dev') && !!cookie.get(`mock-mode-${getTenantName()}-${getTenantApplicationName()}`);
    var inForcedDevMode = new URLSearchParams(window.location.search).get('dev') && !!cookie.get(`mock-mode-${getTenantName()}-${getTenantApplicationName()}`);

    var isInMockMode = function () { return inMockMode; };
    var isInForcedDevMode = function () { return inForcedDevMode; };

    var getMockCookieName = function () {
        return `mock-mode-${getTenantName()}-${getTenantApplicationName()}`;
    }

    var exitMockMode = function () {
        cookie.remove(getMockCookieName());
    }

    var getCqRouterUrl = function () {
        return "https://demo.licquid.com/Web/Licquid/CQDEV/LicquidAction/Get/07e12609-31e1-42b0-8b86-b24a011d7e85"; // TODO kfe put this in Web.config
        // return "http://localhost/Licquid.Web/kfe/MyCQ/Validate/LicquidAction/Get/cfe3b493-be71-4095-9f7f-b22801043403"; // ? kfe for local testing
    }

    // yes, we need to know this
    var browserMatchesChrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
    var isChrome = function () {
        return browserMatchesChrome;
    };

    var isScriptDebuggingEnabled = function () {
        return config.scriptDebuggingEnabled;
    };

    return {
        init: init,
        getNotificationIcon: getNotificationIcon,
        areWebNotificationsEnabled: areWebNotificationsEnabled,
        getFirebaseApiKey: getFirebaseApiKey,
        getFirebaseAppId: getFirebaseAppId,
        getFirebaseProjectId: getFirebaseProjectId,
        getFirebaseSenderId: getFirebaseSenderId,
        getFirebaseWPCert: getFirebaseWPCert,
        getNotificationsEntryPage: getNotificationsEntryPage,
        isScriptDebuggingEnabled: isScriptDebuggingEnabled,
        getStylesVersion: getStylesVersion,
        getTenantName: getTenantName,
        getTenantApplicationName: getTenantApplicationName,
        getBaseUrl: getBaseUrl,
        getCdnUrl: getCdnUrl,
        getTenantUrl: getTenantUrl,
        getTenantCdnUrl: getTenantCdnUrl,
        getRuntimeUrl: getRuntimeUrl,
        getRuntimeBaseUrl: getRuntimeBaseUrl,
        getUserId: getUserId,
        getDesignerId: getDesignerId,
        getDesignerUrl: getDesignerUrl,
        getDesignerBaseUrl: getDesignerBaseUrl,
        getTenantUploads: getTenantUploads,
        getFrontEndUrl: getFrontEndUrl,
        getPortalUrl: getPortalUrl,
        getFullUrl: getFullUrl,
        getNameOfComponent: getNameOfComponent,
        getRavenLogger: getRavenLogger,
        getLanguageIsoCode: getLanguageIsoCode,
        getMockCookieName: getMockCookieName,
        getCqRouterUrl: getCqRouterUrl,
        isInMockMode: isInMockMode,
        isInForcedDevMode: isInForcedDevMode,
        exitMockMode: exitMockMode,
        setRavenLogger: setRavenLogger,
        browser: {
            isChrome: isChrome
        }
    };
});

define('lq', ['lq/main'], function (main) { return main; });

